import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/semester-report/fall-2023/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/annual-report/2023',
  name: 'annual_report_2023',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params, page: route.query.page && +route.query.page }),
  meta: {
    title: '学期报告',
  },
}

export default [indexRoute]
